import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { SideMenu } from '@/shared/presentation/components/admin/SideMenu';
import { FullPageLoading } from '@/shared/presentation/components/FullPageLoading';

import { Header } from '../Header';
import { LayoutViewModel } from './Layout.vm';

const Container = styled.div`
  max-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--gray-02);
`;

const Content = styled.div`
  flex: 1;
  width: var(--content-width);
  margin: 40px auto;
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

export const Layout: React.FC = observer(() => {
  const navigate = useNavigate();
  const vm = useViewModel(LayoutViewModel, { navigate });

  if (!vm.account) {
    return <FullPageLoading />;
  }

  return (
    <Container>
      <Header />
      <Content>
        <SideMenu />
        <Outlet />
      </Content>
    </Container>
  );
});
